import type { CheckStatus } from '@ops-monitor/shared';

const LABELS: Record<CheckStatus, string> = {
  ok: 'норма',
  warn: 'внимание',
  crit: 'проблема',
  nodata: 'нет данных',
};

/**
 * Status as icon + label — never color alone (a11y baseline). The ::before
 * dot carries the color; the text carries the meaning.
 */
export function StatusDot({ status }: { status: CheckStatus }) {
  return (
    <span className={`status-dot status-dot--${status}`} role="status" aria-label={LABELS[status]}>
      {LABELS[status]}
    </span>
  );
}
